export default __webpack_public_path__ + "static/media/ZoneLog_Logger_Flow_Only.bfed18d9.png";